module.exports = __webpack_public_path__ + "img/lecture1-m.83ad7fcd.png";